const initialState = {
    message: undefined,
    canLeaveCallback: () => {},
    bypassBlockNavigation: false,
};

const BYPASS_BLOCK_NAVIGATION = 'BYPASS_BLOCK_NAVIGATION';

export const setBypassBlockNavigation = (data) => ({
    type: BYPASS_BLOCK_NAVIGATION,
    payload: data,
});

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case 'SHOW_BLOCK_NAVIGATION_MODAL':
            return {
                ...state,
                message: action.payload.message,
                canLeaveCallback: action.payload.canLeaveCallback,
            };
        case 'HIDE_BLOCK_NAVIGATION_MODAL':
            return {
                ...state,
                ...initialState,
            };
        case BYPASS_BLOCK_NAVIGATION:
            return {
                ...state,
                bypassBlockNavigation: action.payload,
            };
        default:
            return state;
    }
};
